import Select from './src/Select';

/* istanbul ignore next */
Select.install = function(Vue) {
    Vue.component(Select.name, Select);
};

export default Select;